export default __webpack_public_path__ + "static/media/website_couple_banner.cc2762bc.jpg";